import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/_core/services/common.service';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import Swal from 'sweetalert2';
import { PublicRoutes } from '../../public.routes';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-change-mdp',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule ],
  templateUrl: './change-mdp.component.html',
  styleUrl: './change-mdp.component.css'
})
export class ChangeMdpComponent {
  submitted = false;
  forgotPasswordForm!: FormGroup;
  isLoading: boolean = false;
  showModal: boolean = false;
  private emailForReset: string = '';
  hidePassword = true;
  changePassword!: FormGroup;
  changePasswordWithOtp!: FormGroup;
  currentUser: any;

  constructor(
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private utilities: UtilitiesService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    
    this.initPasswordWithOtpForm();

    // this.changePassword = this.formBuilder.group({
    //   email: [{value: '', disabled: true}], 
    //   codeOtp: ['', Validators.required],
    //   motDePasse: ['', [Validators.required, Validators.minLength(8)], ], // Assurez-vous que c'est une chaîne vide ici
    // }); 
  }
  initPasswordWithOtpForm(): void {
    this.changePasswordWithOtp = this.formBuilder.group({
        email: ['', Validators.required],
        codeOtp: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
        password: ['', [Validators.required, Validators.minLength(8)]]
    });
}
ngAfterViewInit() {
  console.log('État initial du formulaire:', this.changePasswordWithOtp.value);
}
  initPasswordForm(): void {
    this.changePassword = this.formBuilder.group({
      email: [this.currentUser?.email || '', Validators.required],
      codeOtp: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
  }
 
  closeModal() {
    this.showModal = false;
   
  }
  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  get f() {
    return this.changePassword.controls;
  }

  confirmSave() {
    this.submitted = true;
  
    if (this.changePasswordWithOtp.invalid) {
      this.utilities.showNotification(
        'Veuillez saisir un code otp correcte',
        'error'
      );
      return;
    }
  
    // Swal.fire({
    //   title: 'Confirmation',
    //   text: 'Voulez-vous vraiment modifier votre mot de passe ?',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#ff7900',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Oui',
    //   cancelButtonText: 'Non',
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     this.changeMotPasse();
    //   }
    // });
    this.changeMotPasse();
  }

  changeMotPasse(): void {
    // Activer temporairement le champ email pour récupérer sa valeur
    this.changePasswordWithOtp.get('email')?.enable();
    
    const payload = {
      email: this.changePasswordWithOtp.value.email,
      codeOtp: this.changePasswordWithOtp.value.codeOtp,
      password: this.changePasswordWithOtp.value.password
    };
    
    // Désactiver à nouveau le champ
    this.changePasswordWithOtp.get('email')?.disable();
    
    this.authService.changeMotDePasse(payload.email, payload.password, payload.codeOtp)
      .subscribe({
        next: (res) => {
          if (res && !res['hasError']) {
            this.utilities.showNotification(
              'Mot de passe modifié avec succès',
              'success'
            );
            this.closeModal();
            this.router.navigate([PublicRoutes.Signin]);
          } else {
            this.utilities.showNotification(
              res['status']?.message || 'Échec de la modification du mot de passe',
              'error'
            );
          }
        },
        error: (err) => {
          console.error('Erreur:', err);
          this.utilities.showNotification(
            err.error?.message || 'Une erreur est survenue',
            'error'
          );
        }
      });
  }

    saveItem() {
      
      if (this.changePassword.invalid) {
        this.utilities.showNotification(
          'Veuillez corriger les erreurs du formulaire',
          'error'
        );
        return;
      }
  
      const email = this.changePassword.get('email')?.value;

      const { codeOtp, password } = this.changePassword.value;
  
      this.authService
        .changeMotDePasse(email, password, codeOtp)
        .subscribe({
          next: (res: any) => {
            if (res && !res['hasError']) {
              this.utilities.showNotification(
                'Mot de passe modifié avec succès',
                'success'
              );
              this.closeModal();
              this.router.navigate([PublicRoutes.Signin]);
            } else {
              this.utilities.showNotification(
                res['status']?.message ||
                  'Échec de la modification du mot de passe',
                'error'
              );
            }
          },
          error: (error) => {
            console.error('Erreur lors du changement de mot de passe:', error);
            this.utilities.showNotification(
              'Une erreur est survenue lors du changement de mot de passe',
              'error'
            );
          },
        });
    }

get changePasswordControls(): { [key: string]: AbstractControl } {
    return this.changePassword ? this.changePassword.controls : {};
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.changePasswordControls[controlName];
    return control ? this.submitted && control.hasError(errorType) : false;
  }
  onSubmit() {
    this.submitted = true;
    this.isLoading = true;

    if (this.forgotPasswordForm.invalid) {
        this.utilities.showNotification('Une adresse email valide est requise.', 'error');
        this.isLoading = false;
        return;
    }

    const { email } = this.forgotPasswordForm.value;

    this.authService.forgetMdp(email).subscribe({
        next: (res: any) => {
            if (res && !res['hasError']) {
                this.utilities.showNotification(
                    'Un code de réinitialisation a été envoyé à votre adresse email.',
                    'success'
                );

                // Réinitialisation COMPLÈTE du formulaire
                this.changePasswordWithOtp.reset();
                
                // Puis assignation de l'email seulement
                this.changePasswordWithOtp.patchValue({
                    email: email
                });

                this.changePasswordWithOtp.get('email')?.disable();
                this.showModal = true;
            } else {
                this.utilities.showNotification(
                    res.status?.message || 'Erreur lors de la demande de réinitialisation',
                    'error'
                );
            }
        },
        error: (error) => {
            console.error('Erreur HTTP:', error);
            this.utilities.showNotification("Une erreur inattendue s'est produite", 'error');
            this.isLoading = false;
        },
        complete: () => {
            this.isLoading = false;
        },
    });
}

}
